import { createSelector } from 'reselect';
import orderBy from 'lodash/orderBy';
import { getCurrentUser } from '../user/user.selectors';

const allIds = state => state.entities.content.allIds;
const byId = state => state.entities.content.byId;
const showMore = state => state.entities.content.showMore;
const page = state => state.entities.content.page;
const filteredIds = state => state.entities.content.filter.filteredIds;
const filterShowMore = state => state.entities.content.filter.showMore;
const filterPage = state => state.entities.content.filter.page;

const channelsById = state => state.entities.channel.byId;

export const getAllContent = createSelector([byId, allIds, channelsById], (contents, ids, channels) => {
  return ids.map(id => {
    const content = contents[id];

    // convert targetings to a legacy property "channel" used in admin ui
    let channel = content.channel && channels ? channels[content.channel] : null;

    if (content.type === 'news' || content.type === 'inner-circle') {
      channel = content.targetings
        ? (content.channel = content.targetings
            .map(targeting => `${targeting.channel.name} / ${targeting.role}`)
            .join(', '))
        : 'Ei julkaistu';
    }
    return {
      ...content,
      channel,
    };
  });
});

export const getCombinedContent = createSelector(
  [getAllContent, page, showMore],
  (contents, currentPage, shouldShowMore) => {
    let content = orderBy(
      contents.filter(content => content.type === 'news' || content.type === 'inner-circle'),
      'createdAt',
      'desc'
    );
    content.page = currentPage;
    content.showMore = shouldShowMore;
    return content;
  }
);

export const getCombinedFilteredContent = createSelector(
  [getAllContent, filteredIds, filterPage, filterShowMore],
  (contents, ids, currentPage, shouldShowMore) => {
    let content = orderBy(
      contents.filter(
        content =>
          (content.type === 'news' || content.type === 'inner-circle') &&
          (ids.length === 0 || ids.indexOf(content._id) > -1)
      ),
      'createdAt',
      'desc'
    );
    content.page = currentPage;
    content.showMore = shouldShowMore;
    return content;
  }
);

export const getRulesContent = createSelector([getAllContent], contents => {
  return orderBy(contents.filter(content => content.type === 'rules'), 'createdAt', 'desc');
});

export const getRulesForCurrentUser = createSelector([getRulesContent, getCurrentUser], (rules, currentUser) => {
  return orderBy(
    rules.filter(rules => currentUser && rules.channel === currentUser.channel),
    'createdAt',
    'desc'
  ).splice(0, 1);
});

export const getInnerCircleContent = createSelector([getAllContent], contents => {
  return orderBy(contents.filter(content => content.type === 'inner-circle'), 'createdAt', 'desc');
});

export const getNewsContent = createSelector([getAllContent], contents => {
  return orderBy(contents.filter(content => content.type === 'news'), 'createdAt', 'desc');
});



// WEBPACK FOOTER //
// ./src/modules/content/content.selectors.js